module.exports = __webpack_public_path__ + "img/house.6a76c719.png";